import { Injectable } from '@angular/core';
import { EXHIBITORS } from '../../../data/exhibitors';
import { IExhibitor } from '../../../models/exhibitor.model.i';

@Injectable({
    providedIn: 'root'
})

export class ExhibitorService {
    private _exhibitorsMap: Map<number, IExhibitor>;
    private _exhibitors: IExhibitor[];
    private currentExhibitor: IExhibitor;

    constructor() {
        this._exhibitorsMap = new Map(EXHIBITORS);
        this._exhibitors = Array.from(this._exhibitorsMap.values());

    }

    getAllExhibitors(queryTerm?: string): IExhibitor[] {
        if (!queryTerm) {
            return [...this._exhibitors];
        }
        const regex = new RegExp(queryTerm.toLowerCase());
        return this._exhibitors.filter(value => regex.test(value.queryName));
    }

    getExhibitor(id: number | string): IExhibitor {
        id = 'number' === typeof id ? id : Number.parseInt(id);
        return this._exhibitorsMap.get(id);
    }

    getCurrentExhibitor() {
        return this.currentExhibitor;
    }

    setCurrentExhibitor(exhibitor) {
        this.currentExhibitor = exhibitor;
    }

}
